<template>
  <component :is="compToLoad" id="dashboard_root" class="pa-0 ma-0"></component>
</template>

<script>
import Roles from '../../Role.js'

export default {
  name: 'Dashboard',

  computed: {
    compToLoad() {
      if (this.$store.state.currentUser.roles.includes(Roles.ADMIN)) {
        return () => import('./AdminDashboard.vue')
      }
      return () => import('./UserDashboard.vue')
    }
  }
}
</script>

<style>
</style>
